import {
  STORE_REQUEST, GET_STORES_SUCCESS, ADD_STORE_SUCCESS,
  UPDATE_STORE_SUCCESS, DELETE_STORE_SUCCESS, STORE_FLAG_OFF,
} from "../constant";

const initialState = {
  stores: [],
  storeLoading: false,
  isStoreAdded: false,
  isStoreUpdated: false,
  isStoreDeleted: false,
  lastSavedStore: null,
};

export const storeReducer = (state = initialState, action) => {
  switch (action.type) {
    case STORE_REQUEST:
      return { ...state, storeLoading: true };
    case GET_STORES_SUCCESS:
      return { ...state, storeLoading: false, stores: Array.isArray(action.payload) ? action.payload : [] };
    case ADD_STORE_SUCCESS:
      return {
        ...state,
        stores: [...state.stores, action.payload],
        isStoreAdded: true,
        lastSavedStore: action.payload,
      };
    case UPDATE_STORE_SUCCESS:
      return {
        ...state,
        isStoreUpdated: true,
        lastSavedStore: action.payload,
        stores: state.stores.map(s => s._id === action.payload._id ? action.payload : s),
      };
    case DELETE_STORE_SUCCESS:
      return {
        ...state,
        isStoreDeleted: true,
        stores: state.stores.filter(s => s._id !== action.payload),
      };
    case STORE_FLAG_OFF:
      return {
        ...state,
        isStoreAdded: false,
        isStoreUpdated: false,
        isStoreDeleted: false,
        lastSavedStore: null,
      };
    default:
      return state;
  }
};
